import * as React from "react"
import { Appearance, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { FastField, FieldProps } from "formik"
import { FormControl, FormControlProps } from "../../form-control/form-control"
import _ from "lodash"
import { TxKeyPath } from "../../../i18n"
import en from "../../../i18n/en"
import { color } from "../../../theme"
import { FC, useMemo } from "react"
import { FastFieldProps } from "formik/dist/FastField"
import { InputProps } from "../../input/input"

export interface TextFieldProps {
  FieldComponent?: React.ComponentType<any>,
  name: string,
  colorScheme?: "light" | "dark",
  txPrefix?: keyof typeof en,
  input?: any,
  nextInput?: any,
  formControlProps?: FormControlProps
}

const FORM_CONTROL: ViewStyle = {
  paddingHorizontal: 16,
  // marginBottom: 8,
  paddingBottom: 8,
  backgroundColor: color.palette.white
}

const defaultInput: any = {}
const defaultNextInput: any = {}
const defaultFormControlProps: any = {}

const TextFormControl: FC<Omit<TextFieldProps, "FieldComponent"|"name"> & (FastFieldProps | FieldProps)> = observer(function TextFormControl(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    txPrefix, input = defaultInput, nextInput = defaultNextInput,
    formControlProps: { inputProps, ...formControlProps } = defaultFormControlProps,
    field, form: {
      handleChange,
      handleBlur,
      // handleSubmit,
      // isValid
    }, meta
  } = props;

  const column = field.name.split('.').pop()

  const formControlInputProps = useMemo<InputProps>(() => ({
    testID: `jala:id/${field.name}-input`,
    ref: input[field.name],
    autoCapitalize: "none",
    autoComplete: "off",
    autoCorrect: false,
    textContentType: "none",
    keyboardType: "default",
    returnKeyType: nextInput[field.name] ? "next" : "go",
    // onSubmitEditing: () => nextInput[field.name] ? nextInput[field.name]() : (isValid && handleSubmit()),
    onSubmitEditing: () => nextInput[field.name] ? nextInput[field.name]() : undefined,
    placeholderTx: (txPrefix && `${txPrefix}.${_.camelCase(column)}Placeholder` as TxKeyPath) || undefined,
    // defaultValue: meta.initialValue,
    value: field.value,
    onChangeText: handleChange(field.name),
    onBlur: handleBlur(field.name),
    ...inputProps
  }), [column, field.name, field.value, handleBlur, handleChange, input, inputProps, nextInput, txPrefix])

  return (
    <FormControl
      isInvalid={(meta.initialValue || meta.touched) && !!meta.error}
      labelTx={(txPrefix && `${txPrefix}.${_.camelCase(column)}` as TxKeyPath) || undefined}
      colorScheme={colorScheme}
      inputProps={formControlInputProps}
      errorMessage={meta.error}
      style={FORM_CONTROL}
      {...formControlProps}
    />
  );
})

/**
 * Describe your component here
 */
export const TextField = observer(function TextField(props: TextFieldProps) {
  const {
    FieldComponent = FastField,
    name, colorScheme = "light" || Appearance.getColorScheme(),
  } = props

  return (
    <FieldComponent name={name}>
      {(fieldProps) => (
        <TextFormControl colorScheme={colorScheme} {...props} {...fieldProps} />
      )}
    </FieldComponent>
  )
})
